import * as React from 'react';

import './sign-up.css';
import PageFrameSingleForm from '../../common/page-frames/single-form';
import strings from '../../strings';

class SignUpConfirmation extends React.Component {
  public render() {
    return (
      <PageFrameSingleForm
          formTitle={strings.texts.VERIFY_EMAIL}
          title={strings.texts.CREATE_NEW_ACCOUNT}
      >
        <div className="container sign-up-confirmation">
          <div className="columns has-text-centered">
            <div className="column is-fullwidth">
              <span className="icon has-text-grey"><i className="far fa-envelope-open"/></span>
            </div>
          </div>
          <div className="columns has-text-centered">
            <div className="column is-fullwidth">
              <div className="verify-instructions is-size-5">
                {strings.texts.VERIFY_INSTRUCTIONS}
              </div>
            </div>
          </div>
        </div>
      </PageFrameSingleForm>
    );
  }
}

export default SignUpConfirmation;



// WEBPACK FOOTER //
// ./src/pages/sign-up/SignUpConfirmation.tsx